'use strict'
module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/index.js
// module id = 1275
// module chunks = 168707334958949